import React from 'react'
import { Link } from 'react-router-dom'
import O2Footer from './logos/o2-footer'
import './static.sass'

const Footer = () => (
  <footer>
    <span className="text">Film generácia o.z. © 2018</span>
    <span className="slash"> / </span>
    <Link className="gdpr" to="/gdpr">Ochrana osobných údajov</Link>
    <span className="slash"> / </span>
    <Link to="/o-projekte">Podmienky používania</Link>
    <span className="slash"> / </span>
    <span>Ďakujeme: </span>
    <O2Footer />
  </footer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Static/Footer.js